// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".info[data-v-67eec1f0]{background-color:var(--el-background-color-base);margin-bottom:10px;padding:5px 20px}", ""]);
// Exports
module.exports = exports;
